import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_Logical = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Logical"
      videos={[
        "https://www.youtube.com/embed/v_HCUELN7_Y", // Logical Instructions of 8051 Microcontroller
      ]}
      takeaways={[
        { text: "Remember that all logical operations in 8051 are bitwise operations." },
        { text: "Be prepared to analyze logic circuits, derive expressions, and write corresponding assembly code." },
        { text: "Understand how to generate logical operations using AND, OR, XOR, CPL, and SWAP instructions." },
        { text: "Sometimes, you may be given a Karnaugh Map (K-map) and asked to write code for its minimized expression." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_Logical;
